<div mat-dialog-title class="dialog-info" closeOnEscape>
    <label class="dialogTitle">
        {{'WARRANTY' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<div class="row" [formGroup]="warrantyFormGroup">
    <div class="col-md-12">
        <mat-dialog-content class="contentPadding">
            <div class="warranty-rates-container">
                <p class="warranty-rates-label">{{ 'WARRANTY_RATES' | translate}}</p>
                <div class="warranty-cost-container">
                    <p>{{ 'TOTAL_WARRANTY_COST' | translate }}:</p>
                    <p class="warranty-cost-value">{{totalWarrantyCost | multilingualCurrency}}</p>
                </div>
            </div>

            <div class="table-responsive">
                <!-- Lock / unlock toggle -->
                <div class="lock-unlock-container">
                    <span class="icon-group" (click)="lockInputs()">
                        <ng-container *ngIf="isInputsLocked; else unlockIcon">
                            <mat-icon class="lock-icon">lock</mat-icon>
                            <div class="arrow-wrapper">
                                <div class="arrow-tail"></div>
                                <mat-icon class="extended-arrow">arrow_downward</mat-icon>
                            </div>
                            
                        </ng-container>
                        <ng-template #unlockIcon>
                            <mat-icon>lock_open</mat-icon>
                            <mat-icon>arrow_downward</mat-icon>
                        </ng-template>
                        
                    </span>
                </div>

                <table mat-table [dataSource]="warrantyDataSource" [trackBy]="trackByIndex">

                    <!-- Category name column -->
                    <ng-container matColumnDef="warrantyPeriodName">
                        <th mat-header-cell *matHeaderCellDef >
                            {{'WARRANTY_PERIOD' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="tableDefination">
                            {{element.warrantyPeriodName | translate}}
                        </td>
                    </ng-container>

                    <!-- Year 1 rate -->
                    <ng-container matColumnDef="year1Rate">
                        <th mat-header-cell *matHeaderCellDef >{{'ONE' | translate}} </th>
                        <td mat-cell *matCellDef="let element; let i = index" class="tableDefination text-center">
                            <div [formGroupName]="getFormGroupName(i)" class="space-between">
                                <mat-form-field appearance="outline" class="form-field-size">
                                    <input matInput [appNumericMask]="rateConfig" inputmode="decimal"
                                           class="form-input"
                                           [class.no-spin]="isInputsLocked && i > 0"
                                           formControlName="year1Rate">
                                </mat-form-field>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Year 2 rate -->
                    <ng-container matColumnDef="year2Rate">
                        <th mat-header-cell *matHeaderCellDef>{{'TWO' | translate}} </th>
                        <td mat-cell *matCellDef="let element; let i = index" class="tableDefination text-center">
                            <div [formGroupName]="getFormGroupName(i)" class="space-between">
                                <mat-form-field appearance="outline" class="form-field-size">
                                    <input matInput [appNumericMask]="rateConfig" inputmode="decimal"
                                           class="form-input"
                                           [class.no-spin]="isInputsLocked && i > 0"
                                           formControlName="year2Rate">
                                </mat-form-field>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Year 3 rate -->
                    <ng-container matColumnDef="year3Rate">
                        <th mat-header-cell *matHeaderCellDef >{{'THREE' | translate}} </th>
                        <td mat-cell *matCellDef="let element; let i = index" class="tableDefination text-center">
                            <div [formGroupName]="getFormGroupName(i)" class="space-between">
                                <mat-form-field appearance="outline" class="form-field-size">
                                    <input matInput [appNumericMask]="rateConfig" inputmode="decimal"
                                           class="form-input"
                                           [class.no-spin]="isInputsLocked && i > 0"
                                           formControlName="year3Rate">
                                </mat-form-field>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Year 4 rate -->
                    <ng-container matColumnDef="year4Rate">
                        <th mat-header-cell *matHeaderCellDef >{{'FOUR' | translate}} </th>
                        <td mat-cell *matCellDef="let element; let i = index" class="tableDefination text-center">
                            <div [formGroupName]="getFormGroupName(i)" class="space-between">
                                <mat-form-field appearance="outline" class="form-field-size">
                                    <input matInput [appNumericMask]="rateConfig" inputmode="decimal"
                                           class="form-input"
                                           [class.no-spin]="isInputsLocked && i > 0"
                                           formControlName="year4Rate">
                                </mat-form-field>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Year 5 rate -->
                    <ng-container matColumnDef="year5Rate">
                        <th mat-header-cell *matHeaderCellDef >{{'FIVE' | translate}} </th>
                        <td mat-cell *matCellDef="let element; let i = index" class="tableDefination text-center">
                            <div [formGroupName]="getFormGroupName(i)" class="space-between">
                                <mat-form-field appearance="outline" class="form-field-size">
                                    <input matInput [appNumericMask]="rateConfig" inputmode="decimal"
                                           class="form-input"
                                           [class.no-spin]="isInputsLocked && i > 0"
                                           formControlName="year5Rate">
                                </mat-form-field>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Total dollars column: currency display at rest, number input when editing -->
                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'DOLLARS' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index" class="tableDefination right-align">
                            <div [formGroupName]="getFormGroupName(i)" class="space-between">
                                <ng-container *ngIf="editingTotalIndex === i && !isTotalDisabled(i); else displayTotal">
                                    <input matInput [appNumericMask]="sellPriceConfig" inputmode="decimal"
                                           class="form-input no-spin total-input"
                                           formControlName="total"
                                           (blur)="stopEditingTotal()">
                                </ng-container>
                                <ng-template #displayTotal>
                                    <span class="total-display"
                                    [class.readonly-field]="isTotalDisabled(i)"
                                          [class.total-editable]="!isTotalDisabled(i)"
                                          (click)="startEditingTotal(i)">
                                        {{getTotalValue(i) | multilingualCurrency}}
                                    </span>
                                </ng-template>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Year-date subheader row column defs (header-only, not used in data rows) -->
                    <ng-container matColumnDef="nameDate">
                        <th class="noNameWarrantyPeriod" mat-header-cell *matHeaderCellDef></th>
                    </ng-container>
                    <ng-container matColumnDef="year1Date">
                        <th mat-header-cell *matHeaderCellDef >{{yearHeaders[0]}}</th>
                    </ng-container>
                    <ng-container matColumnDef="year2Date">
                        <th mat-header-cell *matHeaderCellDef >{{yearHeaders[1]}}</th>
                    </ng-container>
                    <ng-container matColumnDef="year3Date">
                        <th mat-header-cell *matHeaderCellDef >{{yearHeaders[2]}}</th>
                    </ng-container>
                    <ng-container matColumnDef="year4Date">
                        <th mat-header-cell *matHeaderCellDef >{{yearHeaders[3]}}</th>
                    </ng-container>
                    <ng-container matColumnDef="year5Date">
                        <th mat-header-cell *matHeaderCellDef >{{yearHeaders[4]}}</th>
                    </ng-container>
                    <ng-container matColumnDef="totalDate">
                        <th mat-header-cell *matHeaderCellDef></th>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="rowHeight"></tr>
                    <tr mat-header-row *matHeaderRowDef="yearDateColumns" class="rowHeight year-date-row"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="rowHeight tableDefination"></tr>
                </table>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="actionsPadding">
            <div class="warranty-dates-container">
                <div class="warranty-dates-label">
                    <p class="date-width">{{ 'ESCALATION_START_DATE' | translate}}:</p>
                    <p class="dates-field">{{(jobStartDate | date:'MMM d, yyyy') || '—'}}</p>
                </div>
                <div class="warranty-dates-label">
                    <p class="date-width">{{ 'ESCALATION_END_DATE' | translate}}:</p>
                    <p class="dates-field">{{(jobEndDate | date:'MMM d, yyyy') || '—'}}</p>
                </div>
            </div>
            <div>
                <button class="openCloseBtn" mat-raised-button color="primary">{{'NAVBAR_HELP' | translate}}</button>
                <button class="openCloseBtn" mat-raised-button color="primary" (click)="onSave()">{{'COMMON_DIALOGS_BTN_LABELS_OK' | translate}}</button>
                <button class="openCloseBtn" mat-raised-button color="warn" [mat-dialog-close]>{{'COMMON_DIALOGS_BTN_LABELS_CANCEL' | translate}}</button>
            </div>
        </mat-dialog-actions>
    </div>
</div>
